<template>
    <div class="tab_bar" :class="setTabFixed ? 'fixed-top' : ''">
        <div class="mdc-tab-bar view-tab-bar" role="tablist" id="learnViewTab" ref="learnViewTab">
            <div class="mdc-tab-scroller">
                <div class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll mgb-000">
                    <div class="mdc-tab-scroller__scroll-content">
                        <button class="mdc-tab mdc-tab--active" role="tab" tabindex="0" @click="changeTabType('ViewLesson')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('139')}}
                                    <!-- 레슨 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator mdc-tab-indicator--active">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>
                        <button class="mdc-tab" role="tab" tabindex="1" @click="changeTabType('ViewExam')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('140')}}
                                    <!-- 시험 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>
                        <button class="mdc-tab" role="tab" tabindex="2" @click="changeTabType('ViewMission')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('141')}}
                                    <!-- 미션 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>

                        <button class="mdc-tab" role="tab" tabindex="3" @click="changeTabType('ViewQuestion')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('142')}}
                                    <!-- 질문 -->
                                </span>
                            </span>
                            <span class="mdc-tab-indicator">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 나의 학습 상세 - 서브탭 컴포넌트(my learning view - sub tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'

export default {
    props: ['setTabFixed'],
    data() {
        return {
            learnViewTab: null,
            tabType: 'ViewCourse',
        }
    },

    mounted() {
        this.learnViewTab = new MDCTabBar(document.querySelector('#learnViewTab'))
    },

    updated() {
        this.learnViewTab = new MDCTabBar(document.querySelector('#learnViewTab'))

        if (this.tabType === 'ViewLesson') {
            this.learnViewTab.activateTab(0)
        }else if (this.tabType === 'ViewExam') {
            this.learnViewTab.activateTab(1)
        }else if (this.tabType === 'ViewMission') {
            this.learnViewTab.activateTab(2)
        }else if (this.tabType === 'ViewQuestion') {
            this.learnViewTab.activateTab(3)
        }else {
            this.learnViewTab.activateTab(0)
        }
    },

    computed: {
       isTabType() {
           return this.tabType
       }
    },

    methods: {
        changeTabType(type) {
            this.tabType = type
            this.$emit('setSubTab', type)
        }
        
    }
}
</script>